export default "__VITE_ASSET__UrZZ1EbB__"